import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetPartnerUserDetailById = async (partnerUserId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerUserById?partnerUserId=${partnerUserId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdatePartnerUserDetail = async (partnerUserEmail, partnerUserPassword) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/UpdatePartnerUserDetail?partnerUserEmail=${partnerUserEmail}&partnerUserPassword=${partnerUserPassword}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerUserDependedFeildDataList = async (partner_code) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerUserDependedFeildDataList?partner_code=${partner_code}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerAdminRoleList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetPartnerAdminRoleList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CreatePartnerUser = async (partnerUserData) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/SavePartnerUser`, JSON.stringify(partnerUserData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdatePartnerUser = async (partnerUserData) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Partner/UpdatePartnerUser`, JSON.stringify(partnerUserData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalFilterPartnerUserData = async (Partner_Code, searchData) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetUniversalFilterPartnerUserListData?partner_code=${Partner_Code}&searchdata=${searchData}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CheckPartnerPrimaryUserCount = async (partnerCode) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/CheckPartnerPrimaryUserCount?Partner_Code=${partnerCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}
export const SendPassword = async (staffId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/SendPassword?staffId=${staffId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}
export const GetStaffLoginHistory = async (emailid) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/GetStaffLoginHistory?emailid=${emailid}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ActivateDeactivatePartnerUser = async (Id, IsActive) => {
    const response = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Partner/ActivateDeactivatePartnerUser?id=${Id}&isActive=${IsActive}`, CommonVariables.API_HEADER))
        .then(response => response);
    return response;
}